import React, { useState, useEffect } from "react";
import CardComponent from "../componenti/CardComponent";
import PageWrapper from "../componenti/PageWrapper";
import DashboardGrid from "../componenti/DashboardGrid";
import PageContent from "../componenti/PageContent";
import { CircularProgress, Box } from "@mui/material";
import { API_BASE_URL } from "../context/AuthContext";

export default function Home() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomeCards = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/home_cards.php`);
        const data = await response.json();
        if (Array.isArray(data)) {
          setCards(data);
        }
      } catch (error) {
        console.error("Errore fetch home cards:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHomeCards();
  }, []);

  const fullWidthCards = cards.filter(c => Number(c.is_full_width) === 1);
  const gridCards = cards.filter(c => Number(c.is_full_width) !== 1);

  return (
    <PageWrapper>
      <PageContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={5}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Banner / Card a larghezza intera in alto */}
            {fullWidthCards.map(card => (
              <Box key={card.id} mb={3}>
                <CardComponent
                  backgroundColor={card.bg_color || "#F7E951"}
                  image={card.image_url}
                  title={card.title}
                  text={card.text_content}
                />
              </Box>
            ))}

            {/* Card in Griglia */}
            <DashboardGrid>
              {gridCards.map(card => (
                <CardComponent
                  key={card.id}
                  backgroundColor={card.bg_color || "#D4BBDD"}
                  image={card.image_url}
                  title={card.title}
                  text={card.text_content}
                />
              ))}
            </DashboardGrid>
          </>
        )}
      </PageContent>
    </PageWrapper>
  );
}
